import React from "react";
import {useNavigate} from "react-router-dom";

const TableCardHook = ({header, body, footer, loading}) => {
    const navigate = useNavigate();
    return (
        <div className="is-mobile">
            {loading ? (
                <div className="sm-table-card">
                    <div className="sm-table-heading">
                        <h6>{header.name}</h6>
                    </div>
                    <div className="sm-table-body d-flex flex-wrap">
                        {body.map((item, index) => (
                            <span key={index} className="d-flex flex-grow-1 mb-2">
                                {item.key}: <span className="ms-1">{item.value}</span>
                            </span>
                        ))}
                    </div>
                </div>
            ) : (
                <div className="sm-table-card">
                    <div className="sm-table-heading">
                        <div className="d-flex justify-content-between align-items-center w-100">
                            {/* Left Section: Logo + Slug */}
                            <div className="d-flex align-items-center">
                                {header.icon && (
                                    <img
                                        alt="icon"
                                        src={header.icon}
                                        className="me-2 analysis-icon"
                                        style={{width: 30, height: 30, borderRadius: 19}}
                                    />
                                )}
                                <h6 className="mb-0">{header.name}</h6>
                            </div>

                            {/* Center Section: Category */}
                            {header.centerItem && (
                                <div className="text-center flex-grow-1 d-flex justify-content-center">
                                    {header.centerItem.value}
                                </div>
                            )}

                            {/* Right Section: Percentage */}
                            {header.right_align_text && (
                                <div className="text-end">
                                    <h6 className="text-primary mb-0">{header.right_align_text}</h6>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="sm-table-body d-flex flex-column flex-wrap">
                        {Array.from({length: Math.ceil(body.length / 2)}, (_, rowIndex) => {
                            const leftItem = body[rowIndex * 2];
                            const rightItem = body[rowIndex * 2 + 1];

                            return (
                                <div
                                    key={rowIndex}
                                    className="d-flex justify-content-between mb-2"
                                    style={{width: "100%"}}
                                >
                                    {/* Left Item */}
                                    {leftItem && (
                                        <div className="d-flex me-auto" style={{whiteSpace: "nowrap"}}>
                                            <b>{leftItem.key}</b>:<span className="ms-1">{leftItem.value}</span>
                                        </div>
                                    )}

                                    {/* Right Item */}
                                    {rightItem && (
                                        <div className="d-flex ms-auto" style={{whiteSpace: "nowrap"}}>
                                            <b>{rightItem.key}</b>:
                                            <span className="ms-1 my-auto mx-1">{rightItem.value}</span>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>

                    <div className="sm-table-footer d-flex justify-content-around">
                        {footer.map((item, index) => (
                            <div key={index} className="position-relative d-inline-block">
                                {item.button ? (
                                    item.button
                                ) : (
                                    <button
                                        className="sm-btn-1 position-relative d-flex align-items-center"
                                        onClick={() => {
                                            if (item?.link) {
                                                navigate(item.link);
                                            }
                                        }}
                                    >
                                        {item.icon && (
                                            <img
                                                alt={item.alt}
                                                src={`${window.constants.asset_path}/images/profile_image/account_image/${item.icon}`}
                                                className="me-2 analysis-icon"
                                            />
                                        )}
                                        <span>{item.label}</span>
                                        {item.badge && (
                                            <span className="badge rounded-pill badge-notification bg-danger position-absolute end-0 top-0 translate-middle-y">
                                                {item.badge}
                                            </span>
                                        )}
                                    </button>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default TableCardHook;
